import React, { useState } from 'react';
import MaterialTable from 'material-table';
import AddIcon from '@material-ui/icons/LibraryAdd';
import PrintIcon from '@material-ui/icons/Print';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PhoneIcon from '@material-ui/icons/PhoneAndroid';
import Description from '@material-ui/icons/Description';
import ReceiptLongSvg from 'assets/icons/ReceiptLongSvg';
import PublishIcon from '@material-ui/icons/Publish';
import GetAppIcon from '@material-ui/icons/GetApp';
import LinkIcon from '@material-ui/icons/Link';
import CheckIcon from '@material-ui/icons/Check';
import TableTitle from 'common/components/TableTitle';
import { calculateHeight } from 'common/services/util';
import { getRowStyle } from '../services/config';

const TableReac = ({
    data, columns, loading,
    onAdd, onUpdate, onDelete,
    onPrintLabel, onDuplicate, onTest,
    onCreateTicket, onCreateInvoice,
    onImport, onDownloadTemplate,
    tableRef, title = 'Reacondicionados',
    onColumnDrag,
}) => {
    const [copiedLink, setCopiedLink] = useState(false);

    const handleCopyPublicLink = () => {
        navigator.clipboard.writeText(`${window.location.origin}/reacondicionados`);
        setCopiedLink(true);
        setTimeout(() => setCopiedLink(false), 2000);
    };

    const [pageSize, setPageSize] = useState(() => {
        try {
            const saved = localStorage.getItem('reac_pageSize');
            return saved ? parseInt(saved, 10) : 50;
        } catch { return 50; }
    });

    const handleChangeRowsPerPage = (size) => {
        setPageSize(size);
        try { localStorage.setItem('reac_pageSize', size); } catch {}
    };

    const onColumnDragged = () => {
        if (tableRef && tableRef.current && onColumnDrag) {
            const currentColumns = tableRef.current.dataManager.columns;
            onColumnDrag(currentColumns);
        }
    };

    return (
        <div className="stateful-table" style={{ '--hover-overlay': 'rgba(0,0,0,0.07)' }}>
            <MaterialTable
                tableRef={tableRef}
                title={<TableTitle>{title}</TableTitle>}
                icons={{ Add: () => <AddIcon fontSize="large" color="primary" /> }}
                columns={columns}
                data={data}
                isLoading={loading}
                onColumnDragged={onColumnDragged}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                options={{
                    search: false,
                    sorting: true,
                    filtering: true,
                    actionsColumnIndex: 1,
                    toolbarButtonAlignment: 'left',
                    addRowPosition: 'first',
                    maxBodyHeight: calculateHeight(),
                    pageSize: pageSize,
                    pageSizeOptions: [10, 25, 50, 100],
                    rowStyle: (rowData, index) => getRowStyle(rowData, index),
                }}
                actions={[
                    ...(onDownloadTemplate ? [{
                        icon: () => <GetAppIcon />,
                        tooltip: 'Exportar a Excel',
                        isFreeAction: true,
                        onClick: onDownloadTemplate,
                    }] : []),
                    ...(onImport ? [{
                        icon: () => <PublishIcon />,
                        tooltip: 'Importar Excel (.xlsx)',
                        isFreeAction: true,
                        onClick: onImport,
                    }] : []),
                    ...(onAdd ? [{
                        icon: () => copiedLink
                            ? <CheckIcon style={{ color: '#2e7d32' }} />
                            : <LinkIcon />,
                        tooltip: copiedLink ? '¡Enlace copiado!' : 'Copiar enlace público',
                        isFreeAction: true,
                        onClick: handleCopyPublicLink,
                    }] : []),
                    rowData => ({
                        icon: () => <PrintIcon />,
                        tooltip: 'Imprimir etiqueta',
                        onClick: (_, r) => onPrintLabel(r),
                    }),
                    rowData => ({
                        icon: () => <FileCopyIcon />,
                        tooltip: 'Duplicar artículo',
                        onClick: (_, r) => onDuplicate(r),
                    }),
                    rowData => ({
                        icon: () => <PhoneIcon />,
                        tooltip: 'Test de dispositivo',
                        onClick: (_, r) => onTest(r),
                    }),
                    rowData => ({
                        icon: () => <Description />,
                        tooltip: 'Crear factura',
                        onClick: (_, r) => onCreateInvoice(r),
                    }),
                    rowData => ({
                        icon: () => <ReceiptLongSvg />,
                        tooltip: 'Crear ticket',
                        onClick: (_, r) => onCreateTicket(r),
                    }),
                ]}
                editable={{
                    ...(onAdd ? { onRowAdd: onAdd } : {}),
                    onRowUpdate: onUpdate,
                    onRowDelete: onDelete,
                }}
                localization={{
                    body: {
                        editRow: {
                            deleteText: '¿Eliminar este artículo reacondicionado?',
                            cancelTooltip: 'Cancelar',
                        },
                        addTooltip: 'Añadir artículo',
                        deleteTooltip: 'Eliminar',
                        emptyDataSourceMessage: 'No hay artículos reacondicionados',
                    },
                    toolbar: { searchPlaceholder: 'Buscar' },
                    header: { actions: 'Acciones' },
                    pagination: {
                        labelRowsSelect: 'filas',
                        labelDisplayedRows: '{from}-{to} de {count}',
                        firstTooltip: 'Primera página',
                        previousTooltip: 'Anterior',
                        nextTooltip: 'Siguiente',
                        lastTooltip: 'Última página',
                    },
                }}
            />
        </div>
    );
};

export default TableReac;
